// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3afe3c62] .el-dialog__body {\n  padding-top: 0 !important;\n}\n[data-v-3afe3c62] .el-table .el-form-item.el-form-item--mini {\n  margin: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
